export const UNIQUE_CONFIG_KEY = 'newbuilding-search-frontend';
export const DOM_REACT_CONTAINER_ID = 'newbuilding-search-frontend';
export const PATH_PREFIX_FIRST_PAGE = 'novostroyki';
export const PATH_PREFIX_NON_FIRST_PAGE = 'newobjects/list';
export const PATH_PREFIX_OLD_FILTERS_PAGE = 'newobjects/search';
export const QUERY_PARAM_NAME_PAGE = 'p';
export const NEWBUILDINGS_GK_SUGGEST_COUNT = 25;
export const MAX_ADDRESS_SUGGEST_ELEMENTS = 4;
export const MAX_GEO_SUGGEST_ELEMENTS = 5;
